module.exports = __webpack_public_path__ + "img/celebrationNewNum.6665222f.png";